import http from '@/http'
import { sendErrorToast } from '@/utils/utils'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  sites: null,
  customers: null
}

const mutations = {
  SET_SITES(state, sites) {
    state.sites = sites
  },

  SET_CUSTOMERS(state, customers) {
    state.customers = customers
  }
}

const actions = {
  async fetchSites({ commit }) {
    const token = await Vue.prototype.$user.getIdToken()
    return http
      .get('/context/sites', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => commit('SET_SITES', res.data))
      .catch(e => {
        console.error('Fetch Sites Error', e)
        sendErrorToast('\uD83D\uDEA8 Erreur lors du chargement des sites, veuillez recharger la page')
      })
  },

  async fetchCustomers({ commit }) {
    const token = await Vue.prototype.$user.getIdToken()
    return http
      .get('/context/customers', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => commit('SET_CUSTOMERS', res.data))
      .catch(e => {
        console.error('Fetch Customers Error', e)
        sendErrorToast('\uD83D\uDEA8 Erreur lors du chargement des clients, veuillez recharger la page')
      })
  }
}

const getters = {
  sites: state => state.sites,

  customers: state => state.customers
}

export default {
  state,
  mutations,
  actions,
  getters
}
